<table
  class="hx-calendar-body__table"
  [class.hx-calendar-body__table--large]="cellAspectRatio() !== 1"
  [attr.aria-label]="label()">
  @if (weekdayLabels(); as labels) {
    <thead class="hx-calendar-body__header">
      <tr class="hx-calendar-body__header-row">
        @for (day of labels; track $index) {
          <th class="hx-calendar-body__header-cell" scope="col">
            {{ day }}
          </th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @for (row of rows(); track $index; let rowIndex = $index) {
      <tr class="hx-calendar-body__row">
        @for (cell of row; track $index; let colIndex = $index) {
          @let cellIndex = getCellIndex(rowIndex, colIndex);

          <td
            class="hx-calendar-body__cell"
            [attr.aria-disabled]="!cell.enabled"
            [attr.aria-label]="cell.ariaLabel"
            [attr.aria-selected]="isSelected(cellIndex)"
            [attr.tabindex]="isActive(cellIndex) ? 0 : -1"
            [ngClass]="getCellClasses(cell, cellIndex)"
            (click)="onCellClick(cell, $event)"
            (keydown)="onCellKeydown(cell, $event)"
            (mouseenter)="onCellMouseEnter(cell)"
            (mouseleave)="onCellMouseLeave()">
            <button class="hx-calendar-body__cell-content" tabindex="-1" type="button" [disabled]="!cell.enabled">
              {{ cell.displayValue }}
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
